<template>
  <section :id="$options.name" class="rooms">
    <h2 class="rooms__title">Scegli la tua camera</h2>
    <b-row class="rooms__wrap">
      <b-col xl="9" class="rooms__content">
        <div class="rooms__element" v-for="(room, room_index) in property.rooms" :key="_uid+'_room_'+room_index">
          <room
            v-if="room.rates !== ''"
            :room="room"
            :class="is_selected(room.id) ? 'selected' : ''"
            @toggle-collapse="room_toggle_collapse"
          />
          <b-collapse class="rooms__collapse" :id="_uid + '_room_' + room.id" visible>
            <b-row class="rooms__collapse-row">
              <b-col xl="4" class="rooms__collapse-col">
                <room-summary :room="room" />
              </b-col>
              <b-col xs="12" xl="8" class="rooms__collapse-col">
                <div class="rooms__rates" v-for="rate in room.rates" :key="rate.id">
                  <room-rate
                    :class="is_selected(rate.id) ? 'selected' : ''"
                    :is_selected="is_selected(rate.id)"
                    :room_rate_data="{
                      room: room,
                      rate: rate,
                      radio: selected_radio_value
                    }"
                    @selected-rate="handle_selected_room"
                  />
                </div>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <router-link
          class="rooms__info"
          :to="{ name: 'detail', hash: '#knowbefore' }"
        >
          <span>La struttura potrebbe applicare costi aggiuntivi non mostrati qui sopra. Consulta la sezione <strong class="text-info underline semibold mx-1">Informazioni importanti</strong> per avere più informazioni.</span>
        </router-link>
      </b-col>
      <b-col xl="3" class="rooms__resume">
        <div class="rooms__resume-wrap">
          <resume
            v-if="Object.keys(property_data).length"
            :property_data="property_data"
          />
          <resume-cta :property_data="property_data" />
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { markup } from '@liveeps/utilities'
import Room from '@liveeps/components/blocks/detail/room/room'
import RoomSummary from '@liveeps/components/blocks/detail/room/room-summary'
import RoomRate from '@liveeps/components/blocks/detail/room/room-rate'
import Resume from '@liveeps/components/blocks/resume/resume'
import ResumeCta from '@liveeps/components/blocks/detail/resume-cta'

export default {
  inheritAttrs: false,
  name: 'rooms',

  components: {
    'room': Room,
    'room-summary': RoomSummary,
    'room-rate': RoomRate,
    'resume': Resume,
    'resume-cta': ResumeCta,
  },

  props: {
    property: Object,
  },

  data() {
    return {
      selected_room: null,
      selected_rate: null,
      selected_bed_type: null,
      selected_points: null, // points loyalty
      selected_radio_value: '', // ui only
    }
  },

  watch: {
  },

  computed: {
    ...mapState({
      selected_solution: state => state.liveeps.selected_solution,      
      checkin: state => state.checkin,
      checkout: state => state.checkout,
      occupancy: state => state.occupancy,
    }),

    // Struttura dati provvisoria per componente resume, ci può servire per strutturare il multirooms (store e resume)
    property_data() {
      if (!this.selected_room || !this.selected_rate) return {}

      const { property_id, attributes, fees, policies, ratings, name } = this.property,
            { id: room_id, name: room_name, amenities: room_amenities } = this.selected_room,
            { id: rate_id, amenities: rate_amenities, refundable_before, pricing } = this.selected_rate

      return {
        details: { property_id, attributes, fees, policies, ratings, name },
        room: { id: room_id, name: room_name, amenities: room_amenities },
        rate: { id: rate_id, amenities: rate_amenities, refundable_before, pricing },
        bed_type: this.selected_bed_type,
        amount_points: this.selected_points,
        live_price: pricing && pricing.total ? markup(pricing.total).live_price : null,
      }
    }

  },

  created() {
  },

  mounted() {
  },

  update() {
  },

  methods: {

    // Salva il payload nei data e poi lo emette
    handle_selected_room(payload){
      const { room, rate, bed_type, radio_value, amount_points } = payload

      this.selected_room = room
      this.selected_rate = rate
      this.selected_bed_type = bed_type
      this.selected_radio_value = radio_value
      this.selected_points = amount_points

      this.$emit('handle-property-data', this.property_data)
    },

    // Determina lo stile per room/rate selezionato
    is_selected(id) {
      return (
        (this.selected_room && this.selected_room.id === id) ||
        (this.selected_rate && this.selected_rate.id === id)
      )
    },

    // Emette il toggle dell'elemento collapse con rispettivo id
    room_toggle_collapse(room_id) {
      this.$root.$emit('bv::toggle::collapse', this._uid + '_room_' + room_id)
    }

  },
}
</script>

<style lang="scss" scoped>

  .rooms {
    @extend %section;
    @extend %section_margin;

    &__content {
      margin-top: $grid-gutter-width;
    }

    %is_selected {
      background-color: $selected;
      box-shadow: 0 0 0 1px rgba(0,0,0, .02),0 5px 15px 0 rgba(0,0,0, .10);
      border-color: $info;
    }

    .selected {
      ::v-deep {
        .vb-card__wrap {
          @extend %is_selected;
        }
      }
    }

    ::v-deep {
      .vb-card__wrap {
        border: 1px solid transparent;
      }
    }

    &__title {
      @extend %section__title;
      margin-bottom: 0;
    }

    &__element {
      margin-bottom: $grid-gutter-width;
      position: relative;

      @include media-breakpoint-up(lg){
        position: static;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__collapse {
      padding: 0 10px;

      @include media-breakpoint-up(xl){
        padding: 0;
      }

      &-row {
        margin-top: $grid-gutter-width / 3;
        padding-bottom: $grid-gutter-width / 3;

        @include media-breakpoint-up(xl){
          margin-top: $grid-gutter-width / 2;
          padding-bottom: $grid-gutter-width / 2;
        }
      }

      &-col {
        &:first-child {
          display: none;

          @include media-breakpoint-up(xl){
            display: block;
          }
        }
      }
    }

    &__info {
      border-radius: $border-radius-lg * 2;
      padding: $grid-gutter-20;
      background-color: $selected;
      font-size: $font-size-md;
      color: $dark;
      width: 100%;
    }

    &__resume {
      margin-top: $grid-gutter-width * 2;

      @include media-breakpoint-up(xl){
        margin-top: 0;
      }

      &-wrap {
        @include media-breakpoint-up(xl){
          position: sticky;
          top: $grid-gutter-width / 2;
          margin-top: $grid-gutter-width;
        }
      }
    }

    &__rates{
      margin-bottom: $grid-gutter-width / 2;
      border: 1px solid transparent;

      @include media-breakpoint-up(xl){
        margin-left: -5.7%;
      }

      .selected {
        @extend %is_selected;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

</style>